'use strict';

/*
 * Converts a string into a regular expression.
 * This is effectively a shim for Angular 1.2, as 1.3 does this on its own.
 */

angular.module('msUtility').filter('regex', function () {
  return function (string) {
    if (string) {
      return new RegExp('^' + string + '$');
    } else {
      return new RegExp('^.*$');
    }
  };
});